// A UI unlock only: API token and accounting permissions are still required.
// Never persist the passkey. Scope the unlock to the current login session.
const key = path => `akschap-passkey:${path}`;
export function unlockExpiry(storage, path, identity, now = Date.now()) {
    try {
        const entry = JSON.parse(storage.getItem(key(path)) || 'null');
        return identity && entry?.identity === identity && Number.isFinite(entry.until) && entry.until > now ? entry.until : 0;
    } catch (_) { return 0; }
}
export function rememberUnlock(storage, path, identity, minutes, now = Date.now()) {
    const until = now + minutes * 60000;
    try { if (identity) storage.setItem(key(path), JSON.stringify({ identity, until })); } catch (_) { /* In-memory unlock still works. */ }
    return until;
}
